import classNames from 'classnames';

import AccordionPanel from './AccordionPanel';

import styles from '../../styles/partials/credits.module.css';

interface CreditsProps {
    credits?: Credit[] | null;
    className?: string | null;
    buttonClassName?: string | null;
}

function Credits({ credits = null, className = null, buttonClassName = null }: CreditsProps) {
    const creditsGroups =
        credits !== null
            ? credits.reduce((acc, { name, role }) => {
                  const index = acc.findIndex((item) => item.role === role);
                  return [
                      ...(index === -1 ? acc : acc.slice(0, index)),
                      index === -1
                          ? { role, names: [name] }
                          : {
                                ...acc[index],
                                names: [...(acc[index]?.names || []), name],
                            },
                      ...(index === -1 ? [] : acc.slice(index + 1)),
                  ];
              }, [])
            : null;
    if (creditsGroups === null || creditsGroups.length === 0) {
        return null;
    }
    return (
        <AccordionPanel
            label={<h4 className={styles.label}>Crédits</h4>}
            className={classNames([styles.container, className])}
            buttonClassName={classNames([styles.button, buttonClassName])}
        >
            <ul className={styles.credits}>
                {creditsGroups.map(({ names, role }) => (
                    <li key={`credit-${role}`} className={styles.credit}>
                        <div className={styles.role}>{role}</div>
                        {names.map((name) => (
                            <div className={styles.name} key={`credit-${role}-${name}`}>
                                {name}
                            </div>
                        ))}
                    </li>
                ))}
            </ul>
        </AccordionPanel>
    );
}

export default Credits;
